module.exports = __webpack_public_path__ + "img/45-image-1@2x.a1389f79.png";